import React from 'react'
import { useLocation, useParams} from "react-router-dom"

const Posts = () => {
    // http://localhost:3000/posts/1?name=tid&addr=345
    //console.log(useParams());
    const {id} = useParams();

    const query = new URLSearchParams(useLocation().search);
    
    
    return (
    <div>
    <h2>Posts ID is {id} </h2>
    <h2>Name: {query.get("name")} </h2>
    <h2>Address: {query.get("addr")} </h2>

    
    </div>
  )
}

export default Posts